import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const MetricCardWrapper = styled(Stack)<{ isLoading?: boolean; isDisabled?: boolean; $isActionable: boolean }>`
    padding: 16px 24px;
    flex: 1 1 0;
    border-bottom: 1px solid transparent;
    transition:
        border-color 0.3s linear,
        fill 0.3s linear;

    cursor: ${({ isLoading, isDisabled, $isActionable }) =>
        isLoading || isDisabled ? "not-allowed" : $isActionable ? "pointer" : "default"};

    ${({ $isActionable }) => {
        if (!$isActionable) {
            return "";
        }

        return css`
            &:hover {
                border-bottom-color: ${colorsPalettes.blue["400"]};

                [class^="IconButton"] svg path {
                    fill: ${colorsPalettes.blue["400"]};
                }
            }
        `;
    }}
`;

export const MetricCardContainer = styled(Flex)`
    ${MetricCardWrapper}:first-child {
        border-bottom-left-radius: 6px;
    }

    ${MetricCardWrapper}:nth-child(n) {
        border-right: 1px solid ${colorsPalettes.carbon["50"]};
    }

    ${MetricCardWrapper}:last-child {
        border-right: none;
        border-bottom-right-radius: 6px;
    }
`;

export const MetricCardTitle = styled.h4`
    color: ${colorsPalettes.carbon["500"]};
    font-feature-settings:
        "liga" off,
        "clig" off;
    font-family: "DM Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    margin: 0;
`;

export const IconButton = styled.button`
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: none;
    }
`;
